<template>
  <ForecastsTab
    :product="product"
    :forecast-subscription="forecastSubscription"
  />
</template>

<script lang="ts" setup>
import ForecastsTab from '~/components/reports/ForecastsTab.vue'
import type { TProduct } from '~/src/types/product'
/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  product: TProduct
  forecastSubscription: string
}>()
</script>
